<span *ngIf="showTopOwner" class="badge badge-pill" [class.badge-dark]="theme === 'dark'" [class.badge-light]="theme === 'light'">
  <i [ngClass]="icon"></i>
  {{ this.text }}
</span>
